import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const BusinessLayout = () => {
  return (
    <>
      <div className="main-content">
        <Outlet />
      </div>
    </>
  )
}

export default BusinessLayout 